import { useContext, useState, useEffect } from "react"
import { Link, useNavigate } from "react-router-dom"
import { CircuitoContext } from "../../context/CircuitoContext"
import { UserContext } from "../../context/UserContext"
import { DomainContext } from "./LayoutCircuito"
import { FaHome, FaCheckCircle, FaExclamationTriangle, FaTrophy, FaArrowRight, FaHorseHead } from "react-icons/fa"
import "../../styles/circuitoHomeV2.css"

export default function CircuitoInscreverSe() {
  const { circuito, loadingCircuito } = useContext(CircuitoContext)
  const { user } = useContext(UserContext)
  const { basePath } = useContext(DomainContext)
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const refCodigo = params.get("ref");
    if (refCodigo) {
      localStorage.setItem("afiliado_ref", refCodigo.toLowerCase().trim());
    }
  }, []);

  const handleInscricao = () => {
    if (!user) {
      navigate(`${basePath}/inscrever-se/acesso`)
    } else {
      navigate(`${basePath}/inscrever-se/dados`)
    }
  }

  if (loadingCircuito) {
    return (
      <div className="ch-section">
        <div className="ch-container"><div className="ch-loading">Carregando...</div></div>
      </div>
    )
  }

  if (!circuito) {
    return (
      <div className="ch-section">
        <div className="ch-container">
            <div className="ch-subscribe-card__alert"><FaExclamationTriangle /> Circuito não encontrado.</div>
        </div>
      </div>
    )
  }

  // Lógica para extrair as categorias de forma segura
  const categoriasFormatadas = circuito.categorias?.map(cat => {
    if (typeof cat === "string") {
      return { nome: cat, descricao: "", valorAtual: circuito.taxaInscricao || 0, valorCavalo: 0 };
    }
    
    let precoAtivo = Number(cat.valor || 0);
    let isLote2 = false;
    
    if (cat.dataViradaLote && Number(cat.valorLote2) > 0) {
      if (new Date() > new Date(cat.dataViradaLote)) {
        precoAtivo = Number(cat.valorLote2);
        isLote2 = true;
      }
    }

    return {
      nome: cat.nome,
      descricao: cat.descricao || "",
      valorAtual: precoAtivo,
      valorCavalo: Number(cat.valorCavalo || 0),
      isLote2: isLote2
    };
  }) || [];

  return (
    <div className="ch-page">
      <div className="ch-section">
        <div className="ch-container">
          <nav className="ch-breadcrumb" style={{ marginBottom: "24px" }}>
            <FaHome />
            <Link to={`${basePath}/`}>Início</Link>
            <span>/</span>
            <span>Associação</span>
          </nav>

          <div style={{ maxWidth: "700px", margin: "0 auto", textAlign: "center", marginBottom: "40px" }}>
            <h1 style={{ fontSize: "32px", fontWeight: "800", color: "#fff", marginBottom: "12px", lineHeight: "1.2" }}>
              Associe-se ao <span style={{ color: "var(--c-accent)" }}>{circuito.nome}</span>
            </h1>
            <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "16px", lineHeight: "1.6" }}>
              Confira as categorias disponíveis, escolha a sua e garanta sua vaga no ranking oficial do circuito!
            </p>
          </div>

          <div className="ch-pricing-grid">
            {categoriasFormatadas.map((cat, idx) => (
              <div 
                key={idx} 
                className="ch-pricing-card"
                onClick={handleInscricao} // 💡 CLIQUE NO CARD ATIVADO AQUI
                role="button"
                tabIndex={0}
              >
                
                {cat.isLote2 && (
                  <div className="ch-pricing-badge">Lote Virado</div>
                )}

                <div className="ch-pricing-header">
                  <FaTrophy className="ch-pricing-icon" />
                  <h3 className="ch-pricing-title">{cat.nome.toUpperCase()}</h3>
                  {cat.descricao && (
                    <span className="ch-pricing-desc">({cat.descricao})</span>
                  )}
                </div>

                <div className="ch-pricing-value-box">
                  <span className="ch-pricing-currency">R$</span>
                  <span className="ch-pricing-amount">{cat.valorAtual.toFixed(2)}</span>
                  <span className="ch-pricing-period">/ vaqueiro</span>
                </div>

                {cat.valorCavalo > 0 && (
                  <div className="ch-pricing-extra">
                    <FaHorseHead /> + R$ {cat.valorCavalo.toFixed(2)} por cavalo extra
                  </div>
                )}

              </div>
            ))}
          </div>

          <div style={{ maxWidth: "700px", margin: "40px auto 0", background: "var(--c-card)", padding: "32px", borderRadius: "16px", border: "1px solid rgba(255,255,255,0.05)" }}>
            <h4 style={{ color: "#fff", fontSize: "18px", marginBottom: "16px", display: "flex", alignItems: "center", gap: "8px" }}>
              <FaCheckCircle color="var(--c-accent)" /> Vantagens da Associação
            </h4>
            <ul className="ch-subscribe-card__benefits" style={{ marginBottom: "32px" }}>
              <li><FaCheckCircle /> Pontuação válida em todas as etapas oficiais do circuito</li>
              <li><FaCheckCircle /> Direito a disputar o título de Campeão dos Campeões</li>
              <li><FaCheckCircle /> Acompanhamento de ranking e estatísticas em tempo real</li>
            </ul>

            <button onClick={handleInscricao} disabled={loading} className="ch-btn ch-btn--primary ch-btn--large" style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
              {loading ? "Processando..." : <>Pagar e Associar-se <FaArrowRight /></>}
            </button>

            {!user && (
              <p className="ch-subscribe-card__login-hint" style={{ textAlign: "center" }}>
                Você precisa estar logado para se inscrever. <Link to={`${basePath}/inscrever-se/acesso`}>Fazer login</Link>
              </p>
            )}
          </div>

        </div>
      </div>

      <style>{`
        .ch-pricing-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 24px;
          max-width: 900px;
          margin: 0 auto;
        }

        .ch-pricing-card {
          background: rgba(255,255,255,0.02);
          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: 20px;
          padding: 32px 24px;
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          transition: all 0.3s ease;
          cursor: pointer; /* 💡 CURSOR DE MÃOZINHA ADICIONADO */
          -webkit-tap-highlight-color: transparent;
        }

        .ch-pricing-card:hover {
          background: rgba(255,255,255,0.04);
          transform: translateY(-4px);
          border-color: var(--c-accent);
          box-shadow: 0 12px 30px rgba(0,0,0,0.3);
        }

        /* 💡 EFEITO DE CLIQUE ADICIONADO */
        .ch-pricing-card:active {
          transform: translateY(-1px);
          box-shadow: 0 5px 15px rgba(0,0,0,0.2);
        }

        .ch-pricing-badge {
          position: absolute;
          top: -12px;
          background: #ef4444;
          color: #fff;
          font-size: 11px;
          font-weight: 800;
          padding: 4px 12px;
          border-radius: 20px;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .ch-pricing-header {
          margin-bottom: 24px;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .ch-pricing-icon {
          font-size: 32px;
          color: var(--c-accent);
          margin-bottom: 16px;
        }

        .ch-pricing-title {
          color: #fff;
          font-size: 20px;
          font-weight: 800;
          margin: 0 0 8px 0;
          letter-spacing: 0.5px;
        }

        .ch-pricing-desc {
          color: rgba(255,255,255,0.5);
          font-size: 13px;
          font-style: italic;
          line-height: 1.4;
        }

        .ch-pricing-value-box {
          display: flex;
          align-items: baseline;
          justify-content: center;
          gap: 4px;
          margin-bottom: 16px;
        }

        .ch-pricing-currency {
          font-size: 18px;
          color: rgba(255,255,255,0.6);
          font-weight: 600;
        }

        .ch-pricing-amount {
          font-size: 42px;
          font-weight: 900;
          color: #fff;
          line-height: 1;
        }

        .ch-pricing-period {
          font-size: 14px;
          color: rgba(255,255,255,0.5);
        }

        .ch-pricing-extra {
          display: flex;
          align-items: center;
          gap: 8px;
          background: rgba(255,255,255,0.05);
          padding: 8px 16px;
          border-radius: 8px;
          font-size: 13px;
          color: rgba(255,255,255,0.8);
          margin-top: 8px;
          width: 100%;
          justify-content: center;
        }

        .ch-subscribe-card__benefits {
          list-style: none;
          padding: 0;
        }

        .ch-subscribe-card__benefits li {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px 0;
          color: rgba(255, 255, 255, 0.85);
          font-size: 15px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.06);
        }

        .ch-subscribe-card__benefits li:last-child {
          border-bottom: none;
        }

        .ch-subscribe-card__benefits svg {
          color: var(--c-accent);
          font-size: 18px;
          flex-shrink: 0;
        }

        .ch-btn--large {
          width: 100%;
          padding: 16px 32px;
          font-size: 16px;
          font-weight: bold;
        }

        .ch-subscribe-card__login-hint {
          margin: 16px 0 0;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.6);
        }

        .ch-subscribe-card__login-hint a {
          color: var(--c-accent);
          text-decoration: none;
          font-weight: 600;
        }

        .ch-subscribe-card__login-hint a:hover {
          text-decoration: underline;
        }
      `}</style>
    </div>
  )
}